import {useQuery} from "@tanstack/react-query"
import axios from "axios"
import {AutomationSearchResult} from "../types/Automations";
import qs from 'qs';

interface UseAutomationListQueryProps {
    page: number
    perPage: number,
    otherParams: { [key: string]: any }
}
export default function useAutomationListQuery({
    page,
    perPage,
    otherParams
}: UseAutomationListQueryProps) {
    return useQuery({
        queryKey: ['automations', page, perPage, otherParams],
        queryFn: async () => {
            const GET_AUTOMATIONS_ENDPOINT = '/admin/action/automation/admin/rules';
            const { data } = await axios.get(GET_AUTOMATIONS_ENDPOINT, {
                params: {
                    page: page,
                    count: perPage,
                    ...(otherParams || {})
                },
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
            })
            return {
                nodes: data.COMPANY_AUTOMATIONS.results.map((el : any) => {
                    return el;
                }) as Array<AutomationSearchResult>,
                totalCount: data.COMPANY_AUTOMATIONS.totalCount,
            }
        },
    })
}